export default {
  recoTag: {
    id: 'product_thumb_reco_tag',
    defaultMessage: 'Good deal',
  },
  originalPriceDisplay: {
    id: 'product_thumb_original_price_display',
    defaultMessage: '{price} new',
  },
}
